import { Link } from "react-router-dom";
import { fmtDate } from "@/lib/date";

const tone = (b) => (b.count
  ? (b.tone === "bad" ? "text-[#E53E3E]" : b.tone === "warn" ? "text-[#B4530A]" : "text-[#0055FF]")
  : "text-muted-foreground");

/** The four things that stall a day, each with its oldest offenders. */
export const DayBoard = ({ buckets = [] }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-testid="dayboard">
    {buckets.map((b) => (
      <Link key={b.key} to={b.to} data-testid={`dayboard-${b.key}`}
        className="panel p-4 block hover:border-[#0055FF] transition-colors duration-150 min-w-0 overflow-hidden">
        <div className="flex items-baseline justify-between gap-2">
          <div className="label-xs min-w-0 break-words">{b.title}</div>
          <div className={`mono text-2xl font-black shrink-0 ${tone(b)}`}>{b.count}</div>
        </div>
        <div className="mt-2 space-y-1">
          {b.rows.map((r, i) => (
            <div key={r.id || `${r.label}-${i}`} className="flex items-baseline justify-between gap-2 text-xs min-w-0">
              <span className="truncate min-w-0">
                <span className="mono font-bold">{r.label}</span>{" "}
                <span className="text-muted-foreground">{r.sub}</span>
              </span>
              <span className="mono text-[10px] text-muted-foreground shrink-0">{fmtDate(r.date)}</span>
            </div>
          ))}
          {!b.count && <div className="text-xs text-muted-foreground">All clear.</div>}
        </div>
      </Link>
    ))}
  </div>
);
